<template>
    <div class="bg-white my-0 p-2 rounded d-flex justify-content-between align-items-start" v-if="activeSection">

        <div class="d-flex align-items-center align-items-start" v-if="showBtnDesigns">

            <!-- Editor de Contenido -->
            <ContentEditor />

            <div v-if="shouldShowSeparator" class="separator-item-bar"></div>

            <!-- Configuraciones de Fuente -->
            <FontSettings />

            <!-- Configuraciones de Tabla -->
            <TableSettings />

            <div v-if="showSettingsToTable" class="separator-item-bar"></div>

            <!-- Configuraciones de Alineación -->
            <AlignmentSettings />

            <div class="separator-item-bar"></div>

            <!-- Configuraciones de Bordes -->
            <BorderSettings />

            <div class="separator-item-bar"></div>

            <!-- Configuraciones de Visibilidad -->
            <VisibilitySettings />

        </div>

        <!-- Botones de Acción -->
        <ActionButtons :showBtnActions="showBtnActions" />

    </div>
</template>

<script>

// Generales
import { mapState } from 'vuex';

// Componentes modulares
import ContentEditor from './designBar/ContentEditor.vue';
import FontSettings from './designBar/FontSettings.vue';
import TableSettings from './designBar/TableSettings.vue';
import AlignmentSettings from './designBar/AlignmentSettings.vue';
import BorderSettings from './designBar/BorderSettings.vue';
import VisibilitySettings from './designBar/VisibilitySettings.vue';
import ActionButtons from './designBar/ActionButtons.vue';

export default {

    components: {
        ContentEditor,
        FontSettings,
        TableSettings,
        AlignmentSettings,
        BorderSettings,
        VisibilitySettings,
        ActionButtons
    },

    props: {
        showBtnDesigns: {
            type: Boolean,
            default: true,
            required: false
        },
        showBtnActions: {
            type: Boolean,
            default: true,
            required: false
        }
    },

    computed: {

        ...mapState('labelDesigner', [
            'activeSection',
            'basicValuesDynamicFontSize'
        ]),

        showSettingsToText() {
            if (!this.activeSection) return false
            return this.activeSection && (this.activeSection.type == 'text' || this.activeSection.type == 'TEXT' || this.activeSection.type === 'CLEAR_BOX') ? true : false
        },

        isDifferentToWordDynamicFontSize() {
            const values = this.basicValuesDynamicFontSize
            return (values.find(x => x === this.activeSection.type) || values.find(x => x === this.activeSection.code)) ? false : true
        },

        showSettingsFontSize() {
            return this.showSettingsToText && this.isDifferentToWordDynamicFontSize
        },

        showSettingsMaxFontSize() {
            return this.showSettingsToText && !this.isDifferentToWordDynamicFontSize
        },

        showMaxFontSizeToSpecialSections() {
            return ['PICTOGRAMS', 'WARNING_WORD', 'SAP_NUMBER', 'TRANSPORT', 'HAZARD_STATEMENTS', 'PRECAUTIONARY_INFO', 'EPPS', 'TABLE_COMPONENTS']
                .find(x => this.activeSection.code === x) ? true : false
        },

        showSettingsToTable() {
            return this.activeSection && this.activeSection.code === 'TABLE_COMPONENTS'
        },

        shouldShowSeparator() {
            return this.showSettingsFontSize || this.showSettingsMaxFontSize || this.showMaxFontSizeToSpecialSections || this.showSettingsToTable
        }

    }

};
</script>

<style scoped>

.separator-item-bar {
    width: 1px;
    height: 35px;
    background-color: #e0e0e0;
    margin: 0 10px;
}

</style>
